import type { EmployeeRole } from '../auth';

const ALLOWED_ROLES = new Set(['MANAGER', 'STORE_MANAGER']);

export const isEmployeeRoleAllowed = (role?: EmployeeRole) =>
  role && ALLOWED_ROLES.has(role);
